import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import Immutable from 'immutable';
import { cardShape } from '@bibliocommons/bc-prop-types';
import { Link } from '@bibliocommons/base-links';

import './ContentCardImage.scss';

function renderPlaceholder() {
  return <span />;
}

export default class ContentCardImage extends React.PureComponent {
  state = { usePlaceholder: false };

  handleError = () => {
    this.setState({ usePlaceholder: true });
  };

  renderImage() {
    const { card, handleClick } = this.props;
    const image = card.getIn(['image', 'bwCardImage11'], Immutable.Map());

    return (
      <Link href={card.get('url')} dataKey="card-link" handleClick={handleClick} aria-hidden>
        <img
          src={image.get('url')}
          alt={image.get('altText') || ''}
          aria-hidden={!image.get('isInformative')}
          onError={this.handleError}
          loading="lazy"
        />
      </Link>
    );
  }

  render() {
    const classNames = cn('cp-content-card-image', {
      'content-card-image--compact': this.props.compact
    });

    return <div className={classNames}>{this.state.usePlaceholder ? renderPlaceholder() : this.renderImage()}</div>;
  }
}

ContentCardImage.propTypes = {
  card: cardShape.isRequired,
  compact: PropTypes.bool,
  handleClick: PropTypes.func
};
